import {
  getUserRightsAPI,
  getUserRightsMenuAPI,
  saveUserRightsAPI
} from '../../services/UserRights';

export const fetchUserRights = async (roleGUID) => {
  try {
    const response = await getUserRightsAPI(roleGUID);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      console.log('Error fetching user rights:', response?.message);
      return [];
    }
  } catch (err) {
    console.log('Error fetching user rights:', err);
    return [];
  }
};

export const fetchUserRightsMenu = async (roleGUID) => {
  try {
    const response = await getUserRightsMenuAPI(roleGUID);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      console.log('Error fetching user rights menu:', response?.message);
      return [];
    }
  } catch (err) {
    console.log('Error fetching user rights menu:', err);
    return [];
  }
};

export const saveUserRights = async (payload, successMsg, errorMsg) => {
  try {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const apiPayload = {
      ...payload,
      createdGUID: user.userGUID,
      createdByGUID: user.userGUID,
      modifiedGUID: user.userGUID,
      createdDate: new Date(),
      modifiedDate: new Date()
    };
    const response = await saveUserRightsAPI(apiPayload);

    if (response && response.success) {
      window.showSnackbar({
        message: successMsg || 'User rights saved successfully',
        variant: 'success'
      });
      return response;
    } else {
      window.showSnackbar({
        message: errorMsg || response?.message || 'An error occurred while saving user rights',
        variant: 'error'
      });
      console.log('Error saving user rights:', response?.message);
      return response;
    }
  } catch (err) {
    window.showSnackbar({
      message: errorMsg || err.message || 'An error occurred while saving user rights',
      variant: 'error'
    });
    console.log('Error saving user rights:', err);
    return { success: false };
  }
};
